import type { BetterstartConfig } from '@cli-types/core-engine/config.js'
import { getCurrentCliVersion } from '@cli-utils/paths.js'
import { quoteLiteral } from '@cli-utils/text.js'
import { renderSerializeConfig } from '@core-engine/templates/renderers/config/serialize/serialize-config.js'
import { formatArray } from './format-array.js'

export function serializeConfig(config: BetterstartConfig): string {
  const nextConfig = config.frameworkConfig.next

  return renderSerializeConfig({
    currentCliVersion: quoteLiteral(getCurrentCliVersion()),
    namespace: quoteLiteral(nextConfig.namespace),
    srcDir: nextConfig.srcDir,
    version: nextConfig.version,
    adminPath: quoteLiteral(nextConfig.paths.admin),
    schemasPath: quoteLiteral(nextConfig.paths.schemas),
    pagesPath: quoteLiteral(nextConfig.paths.pages),
    loginPath: quoteLiteral(nextConfig.paths.login),
    apiPath: quoteLiteral(nextConfig.paths.api),
    databaseProvider: quoteLiteral(config.database.provider),
    databaseMigrationsDir: quoteLiteral(config.database.migrationsDir),
    presetsInstalled: formatArray(config.presets.installed),
    integrationsInstalled: formatArray(config.integrations.installed),
    emailProvider: quoteLiteral(config.email.provider),
    storageProvider: quoteLiteral(config.storage.provider),
    linter: quoteLiteral(config.linter),
    generatedEntities: formatArray(config.generated.entities),
    generatedSingles: formatArray(config.generated.singles),
    generatedForms: formatArray(config.generated.forms)
  })
}
